//
//  DocumentationLegacyRichText.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { RichTextSpan, } from "./SDKDocumentationLegacyRichTextSpan";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyRichText {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.spans = model.spans.map((s) => new RichTextSpan(s));
    }
    /** Convert rich text into plain text, omitting any formatting */
    asPlainText() {
        return this.spans.map((s) => s.text).join("");
    }
}
